import { OTPClearLoginState } from "./VerifyOTPManager";
export function buildDeviceHintReauthOTPModel(options) {
    const { deviceHintOTPManager, isSandboxLogin, source, verifyWithClear } = options;
    return {
        formModel: deviceHintOTPManager.formModel,
        maskedPhoneNumber: deviceHintOTPManager.getMaskedPhoneNumber(),
        verifyOTPState: deviceHintOTPManager.verifyOTPState,
        sendOTPState: deviceHintOTPManager.sendOTPState,
        resendCooldownSecondsLeft: deviceHintOTPManager.resendCooldownSecondsLeft,
        isSandboxLogin,
        clearLoginState: OTPClearLoginState.DEFAULT,
        isClearLoggingIn: false,
        verifyWithClear,
        sendVerificationCode: () => deviceHintOTPManager.sendVerificationCode(false, source),
        submitVerificationCode: async () => {
            await deviceHintOTPManager.submitVerificationCode(source);
        },
    };
}
